export default __webpack_public_path__ + "static/media/CloudWatch.15daed0a.md";